import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { Link } from 'react-router-dom';

export const AdminNavbar = () => {
  return (
    <ChakraV3.chakra.nav>
      <ChakraV3.HStack px={4} py={3} gap={4} bg='extraDarkPurple'>
        <Link to={'/admin/onboard'}>
          <ChakraV3.Button size='sm' colorPalette='brand'>
            Onboard
          </ChakraV3.Button>
        </Link>
        <Link to={'/admin/graphiql'}>
          <ChakraV3.Button size='sm' colorPalette='brand'>
            GraphiQL
          </ChakraV3.Button>
        </Link>
      </ChakraV3.HStack>
    </ChakraV3.chakra.nav>
  );
};
